export const LANDINGS = [
  { id: 941, link: '/promresource' },
  { id: 1129, link: '/volgaresource' },
  { id: 619, link: '/transteh' },
  { id: 1175, link: '/rnk' },
  { id: 824, link: '/diesel-promo' },
  { id: 1246, link: '/tatneft' },
  { id: 1137, link: '/tatneft' },
  { id: 883, link: '/rusnpz' },
  { id: 1208, link: '/vezibenzin' },
  { id: 1188, link: '/nk-group' },
  { id: 964, link: '/energy' },
  { id: 450, link: '/resource' },
  { id: 1351, link: '/cupper' },
  { id: 785, link: '/optima' },
  { id: 1250, link: '/karmix' },
  { id: 1377, link: '/technika' },
  { id: 1391, link: '/nipetoil' },
  { id: 1300, link: '/impexneftekhim' },
  { id: 1245, link: '/real-oil' },
  { id: 1240, link: '/petrol-market' },
  { id: 862, link: '/es-oil' },
  { id: 1179, link: '/vikar' },
  { id: 1304, link: '/vdsk' },
  { id: 314, link: '/methaneservice' },
  { id: 702, link: '/mtrast' },
  { id: 738, link: '/sibtire' },
];
